import React, { Component } from "react";
import { connect } from "react-redux";
import { Paper, Grid, Button, Typography, makeStyles, Hidden, AppBar, Tabs, Tab, Avatar } from '@material-ui/core'
import { red } from '@material-ui/core/colors';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import moment from 'moment'
import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import { mostrarModalAddBienestar, mostrarModalDetalleBienestar, mostrarModalFormatosBienestar, mostrarModalMaterialApoyoBienestar, mostrarModalConfirmarRemisionBienestar } from "../../redux/actions/actBienestar";
import { obtenerValoresFiltros, coloresEmma } from "../../global/js/funciones";
import TituloAccion from "../general/TituloAccion";
import TareasTerminadas from "../general/TareasTerminadas";
import AccionesRapidas from '../general/AccionesRapidas'
import ListarDatos from "../general/ListarDatos";
import { BtnDetalle } from "../general/BotonesAccion";
import emma_w from '../../global/imagenes/emma_w.png';
import emma_s from '../../global/imagenes/emma_s1.png';
import revisar from '../../global/imagenes/revisar.png';
import { MenuEstudiante } from "./bienestar_estudiantil/components/BienestarMenu";
import { Bienestar } from "./bienestar_estudiantil/Bienestar";
import BienestarDetalle from "./bienestar_estudiantil/components/BienestarDetalle";
import BienestarFormAgregar from "./bienestar_estudiantil/forms/BienestarFormAgregar";
import BienestarOpcionesTipo from "./bienestar_estudiantil/BienestarOpcionesTipo";
import BienestarActivo from "./bienestar_estudiantil/BienestarActivo";
import {
  TIPOS_SOL,
  COLORES_ESTADO,
  COD_SOL_REM,
  COD_SOL_PASPE,
  COD_ESTADO_AGENDAMIENTO,
  COD_ESTADO_ATENDIDO,
  COD_ESTADO_CIERRE,
  COD_ESTADO_RECHAZO,
  PERFIL_ADMIN,
  PERFIL_ADMIN_BIENESTAR,
  PERFIL_ACUDIENTE,
  PERFILES_ESTUDIANTE,
} from "./helper";
import articleInvestigacion from '../../global/imagenes/articleInvestigacion.png';
import libroabierto from '../../global/imagenes/libro-abierto.png';
import libresPregrado from '../../global/imagenes/librespregrado.png';
import { DetalleAgendamiento } from "./bienestar_estudiantil/Bienestar";
import { fetchHorarioAtencion } from "./bienestar_estudiantil/services/bienestarAdministrarService";
import { debeBloquearCreacion } from "./bienestar_estudiantil/helpers/horarioBienestarUtils";
import AvisoFueraHorario from "./bienestar_estudiantil/components/AvisoFueraHorario";
import {
  fetchEstadosHistoriaBienestar,
  fetchEstadosPorSolicitud,
  fetchLineaBienestar,
  fetchSolicitudesBienestarEstudiante,
} from "./bienestar_estudiantil/services/bienestarEstudianteService";

const useBarraStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  label: {
    fontWeight: 'normal',
  },
  avatarSelec: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: coloresEmma.secondarycolor
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: '#9e9e9e', 
  },
  bar: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
}));

const useTabStyles = makeStyles({
  root: {
    justifyContent: "center"
  },
  scroller: {
    flexGrow: "0"
  }
});

function BarraProcesoCustom({ steps, activeStep, completed = [] }) {
  const classes = useBarraStyles();
  const classes2 = useTabStyles();
  const safeActiveStep = Math.min(Math.max(0, activeStep), steps.length - 1);
  const iconLabel = (num, seleccion, completed) => {
    const isPassed = completed.includes(num) || num === seleccion;
    return (
      <Avatar className={isPassed ? classes.avatarSelec : classes.avatar}>
        <Typography style={{ fontSize: '18px', color: '#ffffff' }} variant="subtitle1" color="textSecondary" component="p">
          {num + 1}
        </Typography>
      </Avatar>
    );
  };

  const renderTabs = () => (
    <AppBar className={classes.bar} position="static" color="default">
      <Tabs
        classes={{ root: classes2.root, scroller: classes2.scroller }}
        value={safeActiveStep}
        variant="scrollable"
        scrollButtons="on"
        indicatorColor="primary"
        textColor="primary"
        aria-label="scrollable force tabs"
      >
        {steps.map(({ label }, key) => (
          <Tab 
            key={key} 
            label={label} 
            icon={iconLabel(key, activeStep, completed)}
          />
        ))}
      </Tabs>
    </AppBar>
  );

  return (
    <div>
      <Hidden smDown>{renderTabs()}</Hidden>
      <Hidden mdUp>{renderTabs()}</Hidden>
    </div>
  );
}


class BienestarEstudiante extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seleccion: 'proceso',
      cargando: true,
      solicitudes_activos: [],
      lineaEstados: [],
      historial: [],
      enListado: true,
      periodo: '',
      dataSolicitud: null,
      vistaDetalle: 'solicitud',
      tipos: [],
      tipoSolicitud: {},
      horario: null,
    }
    this.bienestarDetalleRef = React.createRef();
  }


  esAcudiente = () => String(this.props?.usuario?.perfil?.codigo || '').trim() === PERFIL_ACUDIENTE;

  async componentDidMount() {
    let { mostrarModulo } = this.props;
    mostrarModulo({ ruta: '/bienestar_estudiantil', nombre: 'Bienestar Estudiantil' })
    // El acudiente solo remite: no tiene procesos ni historial propios.
    if (this.esAcudiente()) {
      this.setState({ seleccion: 'agregar' });
      return;
    }
    await this.obtenerDatosIniciales();
    this.abrirFormatosDesdeAviso();
    try {
      if (this.bienestarDetalleRef && this.bienestarDetalleRef.current && typeof this.bienestarDetalleRef.current.verificarRemisionesPendientes === 'function') {
        this.bienestarDetalleRef.current.verificarRemisionesPendientes();
      }
    } catch (err) {
      console.error('Error al invocar verificarRemisionesPendientes desde BienestarEstudiante', err);
    }
  }


  async componentDidUpdate(prevProps, { seleccion, dataSolicitud }) {
    let { seleccion: seleccionNew, dataSolicitud: dataSolicitudNew } = this.state;

    // El usuario de redux puede llegar despues del montaje: al acudiente no se le
    // muestra la bandeja de solicitudes, solo el formulario.
    if (this.esAcudiente() && seleccionNew !== 'agregar') {
      this.setState({ seleccion: 'agregar' });
      return;
    }

    if (dataSolicitudNew && dataSolicitudNew?.id !== dataSolicitud?.id && seleccionNew === 'proceso') this.obtenerDataProcesoActual(dataSolicitudNew.id);

    if (seleccion !== seleccionNew) {
      if (seleccionNew === 'proceso') this.obtenerDatosIniciales();
      else if (seleccionNew === 'historial') this.obtenerHistorial();
      else if (seleccionNew === 'agregar') {
        this.setState({ cargando: true })
        let [tipos, horario] = await Promise.all([
          obtenerValoresFiltros([{ llave: 'generica', valor: TIPOS_SOL }, { llave: 'estado', valor: '1' }]),
          fetchHorarioAtencion(),
        ])
        tipos = this.filtrarTiposPorPerfil(tipos)
        this.setState({ cargando: false, tipos, horario })
      }
    }
  }

  filtrarTiposPorPerfil = (tipos = []) => {
    const codigoPerfil = String(this.props?.usuario?.perfil?.codigo || '').trim();
    const perfilesEstudiante = new Set(PERFILES_ESTUDIANTE);
    const perfilesPaspe = new Set([
      ...perfilesEstudiante,
      PERFIL_ADMIN,
      PERFIL_ADMIN_BIENESTAR,
    ]);

    return (Array.isArray(tipos) ? tipos : []).filter((tipo) => {
      const codigo = tipo?.codigo || '';
      if (codigo === COD_SOL_PASPE) return perfilesPaspe.has(codigoPerfil);
      return true;
    });
  };


  async obtenerDataProcesoActual(id = 0) {
    this.setState({ cargando: true })
    const tipoSolicitudId = this.state.dataSolicitud?.tipo_solicitud?.id || this.state.dataSolicitud?.tipo_solicitud;
    const tipoServicioId = this.state.dataSolicitud?.tipo_servicio?.id || this.state.dataSolicitud?.tipo_servicio;
    let linea = [];
    let estadosPasados = [];

    if (tipoSolicitudId) {
      const lineaPorTipo = await fetchEstadosPorSolicitud(tipoSolicitudId, tipoServicioId, id);
      if (Array.isArray(lineaPorTipo) && lineaPorTipo.length > 0) {
        linea = lineaPorTipo.map(item => (item?.secundario ? item : { secundario: item }));
      }
    }
    
    if (!linea || linea.length === 0) {
      let data = await fetchLineaBienestar(id);
      if (data) {
        if (Array.isArray(data)) {
          linea = data;
        } else {
          linea = data.linea || [];
          estadosPasados = data.estados_pasados || [];
        }
      }
    }

    if (!estadosPasados || estadosPasados.length === 0) {
      estadosPasados = await fetchEstadosHistoriaBienestar(id);
    }

    const lineaNormalizada = Array.isArray(linea) ? linea.map(item => ({
      secundario: item?.secundario || item
    })) : [];

    if (lineaNormalizada.length > 0) {
      this.setState({ lineaEstados: lineaNormalizada, estados_historia: estadosPasados || [] });
    } else {
      const lineaTemplate = (estadosPasados || []).map((estado, idx) => ({
        secundario: {
          id: estado?.tipo_estado?.id || `hist_${idx + 1}`,
          nombre: estado?.tipo_estado?.nombre || `Estado ${idx + 1}`,
          codigo: estado?.tipo_estado?.codigo || '',
          valorc: idx.toString()
        }
      }));
      this.setState({ lineaEstados: lineaTemplate, estados_historia: estadosPasados || [] });
    }

    this.setState({ cargando: false });
  }

  async obtenerDatosIniciales() {
    this.setState({ cargando: true, enListado: true, })
    let periodo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Per_Bienestar' }]);
    if (!periodo || periodo.length === 0 || !periodo[0].nombre) {
      this.setState({ cargando: false });
      actualizarMensaje && actualizarMensaje({ titulo: 'No se encontró un periodo válido para Bienestar Estudiantil.', tipo: 'info', mostrar: true, tiempo: 4000 });
      return;
    }
    let solicitudes_activos_raw = await fetchSolicitudesBienestarEstudiante([{ 'llave': 'periodo', 'valor': periodo[0].nombre }]);
    let solicitudes_activos = Array.isArray(solicitudes_activos_raw) ? solicitudes_activos_raw : [];
    solicitudes_activos = solicitudes_activos.filter(s => {
      const tipoSolicitud = s?.tipo_solicitud?.codigo ?? '';
      if (tipoSolicitud === COD_SOL_REM) {
        const rc = s?.remitente_confirmacion;
        return String(rc) === '1' || String(rc) === '2';
      }
      return true;
    });
    this.setState({ periodo: periodo.length > 0 ? periodo[0].nombre : '', solicitudes_activos, cargando: false })
  }

  pintarProcesoActual() {
    let { enListado } = this.state;
    return enListado ? this.pintarProcesosActivos() : this.pintarProcesoSeleccionado();
  }

  pintarProcesosActivos() {
    let { solicitudes_activos } = this.state;
    if (solicitudes_activos.length === 0) return <div className='pointer' onClick={() => this.setState({ seleccion: 'agregar' })}><TareasTerminadas mensaje='No tienes solicitudes activas, clic aquí para realizar una solicitud' marginTop='7%' imagen={emma_s} widthImg="7%" /></div>;
    return (
      <div style={{ padding: '2% 2% 0% 2%' }} >
        <Grid container direction={'row'} spacing={1} >
          <TituloAccion principal='' alterno='¡ Estas son tus solicitudes para este periodo !' />
          {
            solicitudes_activos.map((data, i) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                  <Paper elevation={1} onClick={() => this.setState({ enListado: false, dataSolicitud: data })} className='pointer'>
                    <BienestarActivo
                      titulo={data.tipo_servicio.nombre}
                      fecha={data.fecha_registro}
                      descripcion={`Tu proceso de ${(data.tipo_servicio.nombre).toLowerCase()} - ${(data.tipo_solicitud.nombre).toLowerCase()} se encuentra ${(data.estado_actual.nombre).toLowerCase()}. Clic aquí para obtener mas información.`}
                      estado={data.estado_actual}
                    />
                  </Paper>
                </Grid>
              )
            })
          }
        </Grid>
      </div>
    )
  }


  lineaDeEstados = () => {
    let { cargando, lineaEstados, dataSolicitud, estados_historia } = this.state;
    if (!cargando && dataSolicitud && Array.isArray(lineaEstados) && lineaEstados.length > 0) {
      const steps = lineaEstados.map(({ secundario }) => ({
        label: secundario?.nombre || 'Estado',
        id: secundario?.id,
        codigo: secundario?.codigo
      }));
      const historial = Array.isArray(estados_historia) ? estados_historia : [];
      const coincide = (step, estado) => {
        if (!estado) return false;
        const { id, codigo, nombre } = step;
        return (
          (estado.id && estado.id === id) ||
          (estado.codigo && estado.codigo === codigo) ||
          ((estado.nombre || '').toLowerCase() === (nombre || '').toLowerCase())
        );
      };

      const estadoActual = dataSolicitud.estado_actual;
      let activeStep = steps.findIndex(step => coincide(step, estadoActual));
      
      if (activeStep === -1) activeStep = 0;
      
      if (estadoActual.codigo === COD_ESTADO_CIERRE) {
        activeStep = lineaEstados.length - 1;
      }

      const completados = [];
      steps.forEach((step, idx) => {
        if (historial.some(h => coincide(step, h?.tipo_estado))) {
          completados.push(idx);
        }
      });

      return <BarraProcesoCustom steps={steps} activeStep={activeStep} completed={completados} />;
    }
    return null;
  };


  pintarProcesoSeleccionado() {
    let { mostrarModalDetalleBienestar, mostrarModalFormatosBienestar, mostrarModalMaterialApoyoBienestar } = this.props
    let { dataSolicitud } = this.state;

    const abrirDetalle = vistaDetalle => {
      this.setState({ vistaDetalle })
      mostrarModalDetalleBienestar(true);
    }

    const abrirFormato = () => {
      mostrarModalFormatosBienestar(true);
    }

    const abrirAdjuntos = () => {
      abrirDetalle('adjuntos');
    }

    const abrirObservacion = () => {
      abrirDetalle('observaciones');
    }

    if (dataSolicitud) {
      return (
        <div className='' >
          <Button onClick={() => this.setState({ enListado: true, dataSolicitud: null })} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon /> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> Atras </Typography> </Button>
          <div style={{ padding: '0% 2% 0% 2%' }} >
            <Grid container direction={'row'} spacing={1} >
              <Grid item xs={12} sm={12} md={6} >
                <TituloAccion principal='' alterno='¡ Información Básica !' />
                <Paper elevation={0} square className="scroll">
                  <Bienestar bienestar={dataSolicitud} />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TituloAccion principal='' alterno='¿ Que deseas hacer ?' />
                <Grid container direction={'row'} spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} sm={12} md={12} >
                    <Paper elevation={3} style={{ border: '1px solid #e0e0e0' }} onClick={() => abrirDetalle()}>
                      <AccionesRapidas imagen={revisar} titulo='¡ Más Información !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes ver toda la información actual.' />
                    </Paper>
                  </Grid>
                  {dataSolicitud.estado_actual.codigo == COD_ESTADO_AGENDAMIENTO && (
                    <Grid item xs={12} sm={12} md={12} >
                        <DetalleAgendamiento datos={dataSolicitud} />
                    </Grid>
                  )}
                {dataSolicitud.estado_actual.codigo === COD_ESTADO_ATENDIDO && (
                  <>
                    <Grid item xs={12} sm={12} md={12}>
                      <Paper elevation={3} style={{ border: '1px solid #e0e0e0' }} onClick={abrirObservacion}>
                        <AccionesRapidas imagen={libroabierto} titulo="Observaciones" sub_titulo="Bien" des_sub_titulo=", Aquí puedes ver todas las observaciones." />
                      </Paper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <Paper elevation={3} style={{ border: '1px solid #e0e0e0' }} onClick={abrirAdjuntos}>
                        <AccionesRapidas imagen={libresPregrado} titulo="Material de Apoyo" sub_titulo="Bien" des_sub_titulo=", Aquí puedes ver todo el material de apoyo." />
                      </Paper>
                    </Grid>
                  </>
                )}

                {[COD_ESTADO_ATENDIDO, COD_ESTADO_CIERRE].includes(dataSolicitud.estado_actual.codigo) && (
                  <Grid item xs={12} sm={12} md={12}>
                    <Paper elevation={3} style={{ border: '1px solid #e0e0e0' }} onClick={abrirFormato}>
                      <AccionesRapidas imagen={articleInvestigacion} titulo="Formatos" sub_titulo="Bien" des_sub_titulo=", Aquí puedes ver todos los formatos." />
                    </Paper>
                  </Grid>
                )}

                </Grid>
              </Grid>
              {
                dataSolicitud.estado_actual.codigo !== COD_ESTADO_RECHAZO &&
                <Grid item xs={12} sm={12} md={12} >
                  <TituloAccion principal='' alterno='¿ Como va mi proceso ?' />
                  {this.lineaDeEstados()}
                </Grid>
              }
            </Grid>
          </div >
        </div>
      )
    }
  }

  abrirFormatosDesdeAviso = () => {
    const { mostrarModalFormatosBienestar } = this.props;
    const params = new URLSearchParams(window.location.search);
    if (params.get('aviso_disentimiento') !== '1') return;

    const { solicitudes_activos } = this.state;
    const pendiente = (Array.isArray(solicitudes_activos) ? solicitudes_activos : [])
      .find((s) => s?.aviso_disentimiento);
    if (!pendiente) return;

    window.history.replaceState({}, '', window.location.pathname);

    this.setState({ seleccion: 'proceso', enListado: false, dataSolicitud: pendiente }, () => {
      mostrarModalFormatosBienestar(true);
    });
  };


  async obtenerHistorial() {
    this.setState({ cargando: true })
    let historial = await fetchSolicitudesBienestarEstudiante();
    this.setState({ historial, cargando: false })
  }

  pintarAvisoFueraHorario() {
    let { horario } = this.state;
    return (
      <Grid container justifyContent="center" style={{ paddingTop: 24 }}>
        <Grid item xs={12} md={10} lg={8}>
          <AvisoFueraHorario horario={horario} />
        </Grid>
      </Grid>
    );
  }

  pintarOpciones = () => {
    let { actualizarMensaje, modalAddBienestar, mostrarModalAddBienestar, usuario } = this.props;
    let { tipos, tipoSolicitud, horario } = this.state;
    const bloqueado = debeBloquearCreacion(horario);

    const tipoSeleccion = tipoSolicitud => {
      if (bloqueado) return;
      this.setState({ tipoSolicitud })
      mostrarModalAddBienestar(true);
    }

    return (
      <>
        {bloqueado && this.pintarAvisoFueraHorario()}
        <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 24 }}  >
          {tipos.length > 0 ?
            tipos.map((tipo) => (
              <Grid item xs={12} md={6} lg={4} style={{ padding: '2% 2% 0% 2%'}} key={tipo.codigo}>
                <Paper
                  elevation={bloqueado ? 1 : 8}
                  square
                  onClick={() => tipoSeleccion(tipo)}
                  style={{
                    borderRadius: '12px',
                    opacity: bloqueado ? 0.5 : 1,
                    cursor: bloqueado ? 'not-allowed' : 'pointer',
                    filter: bloqueado ? 'grayscale(1)' : 'none',
                  }}
                >
                  <BienestarOpcionesTipo
                    avatarcss={{ backgroundColor: red[500] }}
                    data={tipo}
                    image={tipo.archivo}
                  />
                </Paper>
              </Grid>
            ))
            : <TareasTerminadas mensaje="Cargando ..." marginTop="7%" imagen={emma_w} widthImg="7%" />}
        </Grid>

        {tipos.length > 0 && !bloqueado &&
          <BienestarFormAgregar
            actualizarMensaje={actualizarMensaje}
            categoria={''}
            tipo={tipoSolicitud.valorc}
            titulo={`¡ ${tipoSolicitud.nombre ? tipoSolicitud.nombre.charAt(0) + tipoSolicitud.nombre.slice(1).toLowerCase() : ''} !`}
            modalAddBienestar={modalAddBienestar}
            mostrarModalAddBienestar={mostrarModalAddBienestar}
            tipoSolicitud={tipoSolicitud}
            usuario={usuario}
          />
        }
      </>
    );
  };

    pintarHistorial() {
      let { historial } = this.state;
      let { mostrarModalDetalleBienestar } = this.props;
  
      const acciones = (data) => {
        const onClickDetalle = (dataSolicitud) => {
          this.setState({ dataSolicitud, vistaDetalle: 'detalle' }, () => {
            if (typeof mostrarModalDetalleBienestar === 'function') mostrarModalDetalleBienestar(true);
          });
        }
        let detalle = <BtnDetalle callback={() => onClickDetalle(data)} color='#01579b' texto='Abrir' />;
        return detalle;
      }
  
      return (
        <ListarDatos
          datos={historial}
          titulo='Historial de Procesos Bienestar'
          id='tbl_historial_bienestar'
          opciones={true}
          acciones={(data) => acciones(data)}
          buscar={true}
          avatar={({ estado_actual }) => estado_actual.nombre.charAt(0).toUpperCase()}
          color_avatar={({ estado_actual }) => COLORES_ESTADO[estado_actual.codigo] || { backgroundColor: '#B8B8B8', color: '#D9D7D7' }}
          fila_principal={({ tipo_servicio }) => tipo_servicio.nombre}
          filas={[
            { 'id': 'tipo_solicitud', 'mostrar': ({ tipo_solicitud }) => tipo_solicitud.nombre },
            { 'id': 'estado_actual', 'mostrar': ({ estado_actual }) => estado_actual.nombre },
            { 'id': 'fecha_registro', 'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'), 'nombre': 'Fecha Registro : ' },
          ]}
        />
      )
    }


  render() {
    let { seleccion, cargando, dataSolicitud, vistaDetalle } = this.state;
    let { modalDetalleBienestar, 
      modalFormatosBienestar, 
      modalMaterialApoyoBienestar, 
      modalConfirmarRemisionBienestar, 
      mostrarModalConfirmarRemisionBienestar, 
      mostrarModalDetalleBienestar, 
      mostrarModalFormatosBienestar, 
      mostrarModalMaterialApoyoBienestar, 
      actualizarMensaje, 
      usuario } = this.props;
      
    return (
      <div>
        <MenuEstudiante
          seleccionar={(seleccion) => this.setState({ seleccion })}
          sele={seleccion}
          soloNuevo={this.esAcudiente()}
        />
        <div className='contenido_modulo'>
          <BienestarDetalle
            ref={this.bienestarDetalleRef}
            esVistaEstudiante
            modalDetalleBienestar={modalDetalleBienestar}
            modalFormatosBienestar={modalFormatosBienestar}
            modalMaterialApoyoBienestar={modalMaterialApoyoBienestar}
            modalConfirmarRemisionBienestar={modalConfirmarRemisionBienestar}
            actualizarMensaje={actualizarMensaje}
            mostrarModalDetalleBienestar={mostrarModalDetalleBienestar}
            mostrarModalFormatosBienestar={mostrarModalFormatosBienestar}
            mostrarModalMaterialApoyoBienestar={mostrarModalMaterialApoyoBienestar}
            mostrarModalConfirmarRemisionBienestar={mostrarModalConfirmarRemisionBienestar}
            usuario={usuario}
            solicitud = {dataSolicitud}
            bienestar_id={dataSolicitud ? dataSolicitud.id : 0}
            vistaDetalle={vistaDetalle}
            estadoActualProp={dataSolicitud ? dataSolicitud.estado_actual : null}
            recargarSolicitudes={this.obtenerDatosIniciales.bind(this)}
          />

          {
            !cargando
              ?
              <div>
                {seleccion === 'proceso' && this.pintarProcesoActual()}
                {seleccion === 'agregar' && this.pintarOpciones()}
                {seleccion === 'historial' && this.pintarHistorial()}
              </div>
              : <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  let { modalAddBienestar, modalDetalleBienestar, modalFormatosBienestar, modalMaterialApoyoBienestar, modalConfirmarRemisionBienestar } = state.redBienestar;
  return {
    modalAddBienestar,
    modalDetalleBienestar,
    modalFormatosBienestar,
    modalMaterialApoyoBienestar,
    modalConfirmarRemisionBienestar,
    usuario
  }
};

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
  mostrarModalAddBienestar,
  mostrarModalDetalleBienestar,
  mostrarModalFormatosBienestar,
  mostrarModalMaterialApoyoBienestar,
  mostrarModalConfirmarRemisionBienestar,
}

export default connect(mapStateToProps, mapDispatchToProps)(BienestarEstudiante);